// import React from "react";

// function StudentHeader() {
//   return (
//     <header
//       style={{
//         background: "#2563eb",
//         color: "#fff",
//         padding: "18px 40px",
//         display: "flex",
//         justifyContent: "space-between",
//         alignItems: "center",
//         boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
//       }}
//     >
//       <div>
//         <h2 style={{ margin: 0 }}>🎓 VLinkin Student Portal</h2>
//         <p style={{ margin: "5px 0 0" }}>
//           Welcome to Learning Dashboard
//         </p>
//       </div>

//       <button
//         style={{
//           background: "#ef4444",
//           color: "#fff",
//           border: "none",
//           padding: "10px 20px",
//           borderRadius: "6px",
//           cursor: "pointer",
//           fontWeight: "bold",
//         }}
//       >
//         Logout
//       </button>
//     </header>
//   );
// }

// export default StudentHeader;
import React from "react";

function StudentHeader({ onLogout }) {
  return (
    <header
      style={{
        background: "#2563eb",
        color: "#fff",
        padding: "18px 40px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
      }}
    >
      <div>
        <h2 style={{ margin: 0 }}>🎓 VLinkin Student Portal</h2>
        <p style={{ margin: "5px 0 0" }}>
          Welcome to Learning Dashboard
        </p>
      </div>

      <button
        onClick={onLogout}
        style={{
          background: "#ef4444",
          color: "#fff",
          border: "none",
          padding: "10px 20px",
          borderRadius: "6px",
          cursor: "pointer",
          fontWeight: "bold",
        }}
      >
        Logout
      </button>
    </header>
  );
}

export default StudentHeader;